import CardDesignerCardElementBoxShadowControls from './CardDesignerCardElementBoxShadowControls';

export default CardDesignerCardElementBoxShadowControls;
